import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type StoreOperatorRecord = {
  uid: string;
  email?: string;
  enabled: boolean;
  storeIds: string[];
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
};

export const storeOperatorService = {
  async list(): Promise<StoreOperatorRecord[]> {
    const callable = httpsCallable(functions, 'listStoreOperators');
    const res = await callable({});
    const data = (res.data as any) || {};
    return Array.isArray(data.storeOperators) ? (data.storeOperators as StoreOperatorRecord[]) : [];
  },

  async addByEmail(email: string, enabled: boolean, storeIds: string[]): Promise<{ uid: string; email: string }> {
    const callable = httpsCallable(functions, 'addStoreOperatorByEmail');
    const res = await callable({
      email,
      enabled,
      storeIds,
    });
    const data = (res.data as any) || {};
    if (!data.success) {
      throw new Error('Echec addStoreOperatorByEmail');
    }
    return { uid: String(data.uid || ''), email: String(data.email || email) };
  },

  async addByUid(uid: string, enabled: boolean, storeIds: string[], email?: string): Promise<{ uid: string }> {
    const callable = httpsCallable(functions, 'addStoreOperatorByUid');
    const res = await callable({
      uid,
      enabled,
      storeIds,
      email,
    });
    const data = (res.data as any) || {};
    if (!data.success) {
      throw new Error('Echec addStoreOperatorByUid');
    }
    return { uid: String(data.uid || uid) };
  },

  async update(uid: string, updates: { enabled?: boolean; storeIds?: string[] }): Promise<{ uid: string }> {
    const callable = httpsCallable(functions, 'updateStoreOperator');
    const res = await callable({
      uid,
      ...updates,
    });
    const data = (res.data as any) || {};
    if (!data.success) {
      throw new Error('Echec updateStoreOperator');
    }
    return { uid: String(data.uid || uid) };
  },

  async remove(uid: string): Promise<{ uid: string }> {
    const callable = httpsCallable(functions, 'removeStoreOperatorByUid');
    const res = await callable({ uid });
    const data = (res.data as any) || {};
    if (!data.success) {
      throw new Error('Echec removeStoreOperatorByUid');
    }
    return { uid: String(data.uid || uid) };
  },
};

export default storeOperatorService;
